<template>
  <BaseSlideOverModal v-model:is-modal-open="localOpen" width="4xl">
    <template #body>
      <ActivityContainer :activities="activities" />
    </template>
  </BaseSlideOverModal>
</template>

<script>
import { mapActions } from 'vuex'
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import ActivityContainer from '@c/Activity/ActivityContainer.vue'

export default {
  name: 'ActivityLogModal',
  components: {
    ActivityContainer,
    BaseSlideOverModal
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    modelType: {
      type: String,
      required: true
    },
    modelId: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'update:open'],
  data() {
    return {
      activities: []
    }
  },
  computed: {
    localOpen: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    }
  },
  watch: {
    open(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.fetchActivities()
      }
    }
  },
  methods: {
    ...mapActions({
      processFetchActivitiesAction: 'activityLog/fetchActivities'
    }),
    fetchActivities() {
      this.processFetchActivitiesAction({
        id: this.modelId,
        model: this.modelType
      }).then((response) => {
        this.activities = response.activities
      })
    }
  }
}
</script>
